import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from '../../../../../../../../shared/frontend/components/presentational/spinner';
import LoadableRecruitmentProfilePreview from './loadableRecruitmentProfilePreview';
import { actions } from './modules';
import { localRecruitmentProfilesSelector } from './selectors';
import { navigateTo } from '../../../../../../../../shared/frontend/libs/history';
import PatronLevel from '../../../../../../../../shared/frontend/components/patreon/patronLevel';
import { RecruitmentEntityType } from '../../../../../../../../shared/types/recruitmentTypes';
import { getProfileTarget } from '../../../../../../../../shared/frontend/scripts/recruitment/utils';

type TFetchableRecruitmentProfilePreviewProps = {
  link?: string;
  profileId: number;
};

export const FetchableRecruitmentProfilePreview = (props: TFetchableRecruitmentProfilePreviewProps) => {
  const dispatch = useDispatch();
  const { profileId } = props;

  const profiles = useSelector(localRecruitmentProfilesSelector);

  const { loading, loaded, error, profile } = profiles[profileId] || {};

  if (profileId && _.isEmpty(profile) && !loading && !loaded) {
    dispatch(actions.fetchRecruitmentProfile(profileId.toString()));
  }

  if (loading) {
    return (
      <div style={{ minWidth: 200, minHeight: 100 }}>
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="character-recruitment-preview--recruitPanelContent rio-shadow--medium character-recruitment-preview--profile-border slds-text-align--center slds-align--absolute-center text-bold"
        style={{ minWidth: 400, maxWidth: 400, minHeight: 200 }}
      >
        Profile has Expired or was Deactivated
      </div>
    );
  }

  if (!_.isEmpty(profile)) {
    const elem = (
      <PatronLevel
        patronLevel={profile.patronLevel?.level}
        isHidden={profile.entity_type === RecruitmentEntityType.Guild}
      >
        <LoadableRecruitmentProfilePreview
          target={getProfileTarget(profile)}
          profile={profile}
          profileType={profile.entity_type}
          showPatronLabel
        />
      </PatronLevel>
    );

    return (
      <div
        style={props.link ? { cursor: 'pointer' } : {}}
        onClick={props.link ? (e: any) => navigateTo(props.link!, e) : undefined}
        className="rio-shadow--medium character-recruitment-preview--profile-border"
      >
        {elem}
      </div>
    );
  }

  // if a profile was deleted or an invalid id was sent
  return (
    <div
      className="slds-text-bold slds-align--absolute-center character-recruitment-preview--recruitEmptyPanel"
      style={{ minHeight: 200, minWidth: 400 }}
    >
      Profile no longer exists
    </div>
  );
};
